import { Shark, View } from "shark-mvc";

import User from "../../models/User";

import templateContent from "./password-recovery.html";

import mainNavComponent from "../../components/mainNav/mainNavComponent";
import userManager from "../../controllers/userManager";

class PasswordRecoveryView extends View {
	constructor() {
		super("passwordRecoveryView");
		
		this.$mainRoute = "request-new-password";
		this.setTemplate(templateContent);
	}

	beforeLoad () {
		const lastUserEMail = localStorage.getItem("lastUserEMail") || "";
		const currUser = new User({email: lastUserEMail});

		currUser.set({password: ""});

		Shark.set({
			confirmSent: false,
			currUser,
			errorNotPresent: false,
			requestPending: false,
			showForm: true,
		});
	}

	init () {
		this.addComponents([mainNavComponent]);
	}

	recoverPasswordForm_submitHandler (event) {
		event.preventDefault();
		event.stopPropagation();

		return false;
	}

	sendPasswordRecoveryRequest () {
		const currUser = Shark.get("currUser");

		if (!currUser.isValid("requestPasswordRecovery")) {
			currUser.set({
				email: document.querySelector("#emailField").value,
			});
		}

		if (currUser.isValid("requestPasswordRecovery")) {
			Shark.set({
				requestPending: true,
			});
			Shark.render();

			userManager.requestNewPassword(currUser)
			.then(response => {
				Shark.set({
					confirmSent: response && response.status === "ok",
					errorNotPresent: false,
					loginError: false,
					requestPending: false,
					showForm: false,
				});
				Shark.render();
			});
		}
		else {
			Shark.render();
		}
	}

	sendPasswordRecoveryRequestBtn_clickHandler () {
		this.sendPasswordRecoveryRequest();
	}
}

const passwordRecoveryView = new PasswordRecoveryView();

Shark.registerView(passwordRecoveryView);

export default passwordRecoveryView;
